/*
 *
 * PatientSchedule actions
 *
 */
import {
	FETCH_PROFILE,
	FETCH_PROFILE_FAILURE,
	FETCH_PROFILE_SUCCESS,
	FETCH_SESSIONS,
	FETCH_SESSIONS_FAILURE,
	FETCH_SESSIONS_SUCCESS,
} from './constants';

export function fetchSessions() {
	return {
		type: FETCH_SESSIONS,
	};
}

export function fetchSessionsSuccess(events) {
	return {
		type: FETCH_SESSIONS_SUCCESS,
		events,
	};
}

export function fetchSessionsFailure(error) {
	return {
		type: FETCH_SESSIONS_FAILURE,
		error,
	};
}

export function fetchProfile(userId) {
	return {
		type: FETCH_PROFILE,
		userId,
	};
}

export function fetchProfileSuccess(profile) {
	return {
		type: FETCH_PROFILE_SUCCESS,
		profile,
	};
}

export function fetchProfileFailure(error) {
	return {
		type: FETCH_PROFILE_FAILURE,
		error,
	};
}
